export type AnyDate =
  | Date
  | string
  | number
  | { toDate?: () => Date }
  | { seconds?: number; nanoseconds?: number }
  | null
  | undefined;

export function toDate(input: AnyDate): Date | null {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input.getTime()) ? null : input;

  if (typeof input === 'object') {
    if ('toDate' in input && typeof (input as any).toDate === 'function') {
      const d = (input as any).toDate();
      return isNaN(d.getTime()) ? null : d;
    }
    if ('seconds' in input && typeof (input as any).seconds === 'number') {
      const d = new Date((input as any).seconds * 1000);
      return isNaN(d.getTime()) ? null : d;
    }
  }

  const d = new Date(input as string | number);
  return isNaN(d.getTime()) ? null : d;
}

export function formatTimeAgo(input: AnyDate): string {
  const date = toDate(input);
  if (!date) return '';

  const diffMs = Date.now() - date.getTime();
  const sec = Math.floor(diffMs / 1000);
  if (sec < 60) return `${sec}s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m`;
  const hrs = Math.floor(min / 60);
  if (hrs < 24) return `${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo`;
  const years = Math.floor(days / 365);
  return `${years}y`;
}
